var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Logo_PLK_logo",
    width: 165.109,
    height: 26,
    "data-name": "Logo/PLK_logo",
    viewBox: "0 0 165.109 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5",
    d: "M132.045 18.331a1.559 1.559 0 1 0 1.565 1.553 1.536 1.536 0 0 0-1.565-1.553zm0 2.89a1.332 1.332 0 1 1 1.28-1.336 1.271 1.271 0 0 1-1.28 1.335z",
    className: "prefix__cls-1",
    "data-name": "Path 5",
    transform: "translate(31.498 4.425)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6",
    d: "M132.632 19.394c0-.4-.263-.548-.72-.548h-.7v1.839h.354V19.9h.228l.457.788h.377l-.492-.8c.278-.025.496-.151.496-.494zm-1.063.228v-.48h.309c.171 0 .376.034.376.228 0 .228-.16.251-.365.251z",
    className: "prefix__cls-1",
    "data-name": "Path 6",
    transform: "translate(31.678 4.55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_7",
    d: "M86.053 25.449h7.973V18.71l9.343-17.7h-8.475L90.1 11.354 85.5 1.005h-8.322L86.053 18.7z",
    className: "prefix__cls-1",
    "data-name": "Path 7",
    transform: "translate(18.632 .243)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8",
    d: "M9.812.037C6.945-.1 2.079.174 0 .323l.171 6.191 1.987-.126v19.281h7.665v-4.82c11.205-.537 13.821-6.511 13.821-10.726C23.633 4.149 18.767.46 9.812.037zm.011 14.8V6.422c4.877.228 6.054 2.319 6.054 4.021 0 2.41-1.622 4.306-6.054 4.398z",
    className: "prefix__cls-1",
    "data-name": "Path 8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_9",
    d: "M108.329.278c-7.4 0-12.519 5.368-12.519 12.759s4.934 12.9 13.238 12.9a15.6 15.6 0 0 0 8.978-2.456l-2.752-5.665a10.545 10.545 0 0 1-5.905 1.793c-3.061 0-4.968-1.462-5.711-3.986h16.3a20.847 20.847 0 0 0 .252-3.438c-.059-5.27-2.835-11.907-11.881-11.907zm-4.763 10.154c.593-2.467 2.17-4.146 4.775-4.146a4.2 4.2 0 0 1 4.5 4.146z",
    className: "prefix__cls-1",
    "data-name": "Path 9",
    transform: "translate(23.13 .067)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10",
    d: "M49.862.24C47.029.1 42.2.366 40.153.525l.16 6.122 1.965-.126v19.088h7.584v-4.775c11.091-.525 13.684-6.442 13.684-10.611 0-5.905-4.821-9.56-13.684-9.983zm0 14.655V6.556c4.832.228 6 2.3 6 3.986-.003 2.399-1.603 4.258-6 4.353z",
    className: "prefix__cls-1",
    "data-name": "Path 10",
    transform: "translate(9.694 .049)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_11",
    d: "M128.725 11.088c-1.371-.548-3.015-1.165-4.089-1.645-1.05-.48-1.417-.948-1.417-1.668 0-.959.994-1.485 2.251-1.485a6.4 6.4 0 0 1 4.8 2.342l4.249-4.42c-1.827-2.456-4.946-4-8.943-4-5.415 0-9.63 2.6-9.63 7.756 0 4.066 1.954 6.02 5.758 7.664 1.074.468 2.524.88 3.6 1.337.948.4 1.542.822 1.542 1.6 0 .72-.628 1.3-2.455 1.3a11.826 11.826 0 0 1-5.871-1.828l-2.582 5.3a14.218 14.218 0 0 0 8.464 2.513c4.717 0 9.766-2.045 9.766-7.527-.006-4.144-2.645-6.108-5.443-7.239z",
    className: "prefix__cls-1",
    "data-name": "Path 11",
    transform: "translate(27.988 .052)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_12",
    d: "M32.475.407a12.555 12.555 0 0 0-12.9 12.644 12.555 12.555 0 0 0 12.9 12.649 12.555 12.555 0 0 0 12.9-12.644A12.548 12.548 0 0 0 32.475.407zm.058 18.493c-3.415 0-5.586-2.627-5.586-5.905s2.17-5.905 5.586-5.905 5.586 2.627 5.586 5.905-2.16 5.905-5.586 5.905z",
    className: "prefix__cls-1",
    "data-name": "Path 12",
    transform: "translate(4.727 .098)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_13",
    d: "M72.012.278c-7.4 0-12.519 5.368-12.519 12.759s4.832 12.9 13.307 12.9a15.546 15.546 0 0 0 9.766-2.981l-2.992-5.476a11.015 11.015 0 0 1-6.454 2.113c-3.187 0-5.071-1.462-5.791-3.986H83.64a20.927 20.927 0 0 0 .251-3.438C83.846 6.915 81.07.278 72.012.278zm-4.751 10.155c.594-2.467 2.17-4.146 4.775-4.146a4.187 4.187 0 0 1 4.489 4.146z",
    className: "prefix__cls-1",
    "data-name": "Path 13",
    transform: "translate(14.363 .067)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlk);
export default __webpack_public_path__ + "static/media/logo-plk.69a232e74cfef774cd8ece90d0fdc9e0.svg";
export { ForwardRef as ReactComponent };